export default "__VITE_ASSET__DOKf_9gG__"